import Layout from "../../components/shared/layout";
import {Box, Button, Card, CardContent, CardMedia, Container, Divider, Grid, Stack, Typography} from "@mui/material";
import {Link} from "react-router-dom";
import Stat from "../../components/shared/stat";
import {ArrowRight, DoneOutline} from "@mui/icons-material";
import {WSF_DATA} from "../../utils/data";
import Carousel from "react-multi-carousel";
import Review from "../../components/shared/review";
import 'react-multi-carousel/lib/styles.css';
import balloons from "./../../assets/images/madison-oren-uGP_6CAD-14-unsplash.jpg";
import newFeature from "./../../assets/images/brooke-cagle-tLG2hcpITZE-unsplash.jpg";
import availableFunds from "./../../assets/images/hannah-busing-Zyx1bK9mqmA-unsplash.jpg";
import communityImpact from "./../../assets/images/josh-appel-0nkFvdcM-X4-unsplash.jpg";
import grantPrograms from "./../../assets/images/nicole-baster-OJcEMZHoY80-unsplash.jpg";

import smallBusinessGrant from "../../assets/images/artem-gavrysh-F6-U5fGAOik-unsplash.jpg";
import studentGrant from "../../assets/images/brooke-cagle--uHVRvDr7pg-unsplash.jpg";
import businessImprovementGrant from "../../assets/images/clem-onojeghuo-c4pbb7yNM2c-unsplash.jpg";
import fundraisingEvent from "../../assets/images/pietro-rampazzo-x5GcXFvJJhI-unsplash.jpg";
import beADonor from "../../assets/images/duy-pham-Cecb0_8Hx-o-unsplash.jpg";
import fundraiser from "../../assets/images/gene-gallin-UHNKI8UUyIg-unsplash.jpg";
import {motion} from "framer-motion";

const HomePage = () => {
    return (
        <Layout>
            <Box sx={{py: 7.1}}>
                <Box
                    sx={{
                        minHeight: {xs: "70vh", md: "80vh", lg: "100vh"},
                        borderBottomRightRadius: {xs: 32},
                        borderBottomLeftRadius: {xs: 32},
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "background.alternative",
                        py: 8
                    }}>
                    <Container
                        whileInView={{
                            y: 0,
                            opacity: 1,
                            transition: {
                                duration: 1
                            }
                        }}
                        initial={{
                            y: "10vh",
                            opacity: 0
                        }}
                        component={motion.div}
                        maxWidth="xl">
                        <Grid container={true} spacing={4} justifyContent="space-between" alignItems="center">
                            <Grid item={true} xs={12} md={6} lg={6}>
                                <Box>

                                        <Typography
                                            sx={{color: "secondary.main", textTransform: "uppercase", mb: 2}}
                                            variant="body1">
                                            Grant Program
                                        </Typography>
                                        <Typography
                                            sx={{
                                                backgroundImage: "linear-gradient(to right, #af795d , #000000)",
                                                backgroundClip: "text",
                                                fontSize: {xs: 32, md: 44, lg: 72},
                                                color: "transparent",
                                            }}
                                            variant="h3">
                                            Convenience comes with Federal Grants...
                                        </Typography>
                                        <Typography
                                            sx={{
                                                backgroundImage: "linear-gradient(to right, #af795d , #000000)",
                                                backgroundClip: "text",
                                                fontSize: {xs: 32, md: 44, lg: 72},
                                                color: "transparent",
                                                mb: 1
                                            }}
                                            variant="h3">
                                            Get with Ease.
                                        </Typography>
                                        <Typography
                                            sx={{color: "text.secondary", mb: 4}}
                                            variant="body1">
                                            Making government services easier to find.
                                        </Typography>
                                        <Box>
                                            <Grid container={true} spacing={2}>
                                                <Grid item={true} xs={12} md={6}>
                                                    <Link to="/us" style={{textDecoration: "none"}}>
                                                        <Button
                                                            fullWidth={true}
                                                            disableElevation={true}
                                                            variant="contained"
                                                            size="large"
                                                            color="secondary"
                                                            sx={{textTransform: "none", py: 1.2}}>
                                                            Grant Programs
                                                        </Button>
                                                    </Link>
                                                </Grid>
                                                <Grid item={true} xs={12} md={6}>
                                                    <Link to="/apply" style={{textDecoration: "none"}}>
                                                        <Button
                                                            fullWidth={true}
                                                            disableElevation={true}
                                                            variant="outlined"
                                                            size="large"
                                                            color="secondary"
                                                            sx={{textTransform: "none", py: 1.2}}>
                                                            Apply Now
                                                        </Button>
                                                    </Link>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                </Box>
                            </Grid>
                            <Grid item={true} xs={12} md={6} lg={4}>
                                <CardMedia
                                    component="img"
                                    sx={{
                                        objectFit: "contain",
                                        borderTopRightRadius: 64,
                                        borderTopLeftRadius: 128,
                                        borderBottomLeftRadius: "5%",
                                        borderBottomRightRadius: "5%",
                                        height: "80%"
                                    }}
                                    src={balloons}
                                />
                            </Grid>
                        </Grid>
                    </Container>
                </Box>
                <Box
                    whileInView={{
                        y: 0,
                        opacity: 1,
                        transition: {
                            duration: 1
                        }
                    }}
                    initial={{
                        y: "10vh",
                        opacity: 0
                    }}
                    component={motion.div}
                    sx={{
                        py: 8,
                        borderBottomRightRadius: 32,
                        borderBottomLeftRadius: 32,
                        backgroundColor: "background.paper",
                    }}>
                    <Container maxWidth="xl">
                        <Box
                            sx={{
                                py: 2,
                                backgroundColor: "secondary.main",
                                borderRadius: {xs: 1, md: 1, lg: 1},
                                mt: {xs: 0, md: -20}
                            }}>
                            <Container maxWidth="xl">
                                <Grid container={true} spacing={2}>
                                    <Grid item={true} xs={12} md={3}>
                                        <Stat title="Donation Reach" value={588}/>
                                    </Grid>
                                    <Grid item={true} xs={12} md={3}>
                                        <Stat title="Company Donor" value={168}/>
                                    </Grid>
                                    <Grid item={true} xs={12} md={3}>
                                        <Stat title="Personal Donor" value={895}/>
                                    </Grid>
                                    <Grid item={true} xs={12} md={3}>
                                        <Stat title="Organization Apply" value={487}/>
                                    </Grid>
                                </Grid>
                            </Container>
                        </Box>
                    </Container>
                </Box>

                <Box
                    whileInView={{
                        y: 0,
                        opacity: 1,
                        transition: {
                            duration: 1
                        }
                    }}
                    initial={{
                        y: "10vh",
                        opacity: 0
                    }}
                    component={motion.div}
                    sx={{
                        py: 8,
                        borderBottomRightRadius: 64,
                        borderBottomLeftRadius: 64,
                        backgroundColor: "background.default",
                    }}>
                    <Container maxWidth="xl">
                        <Grid spacing={4} container={true}>
                            <Grid item={true} xs={12} md={6}>
                                <Typography
                                    sx={{color: "secondary.main", textTransform: "uppercase", mb: 2}}
                                    variant="body1">
                                    Who can apply
                                </Typography>
                                <Typography
                                    sx={{
                                        backgroundImage: "linear-gradient(to right, #af795d , #000000)",
                                        backgroundClip: "text",
                                        color: "transparent",
                                        mb: 4
                                    }}
                                    variant="h4">
                                    Our Grant Program Is Open To Registered Non-Profit Organizations
                                </Typography>
                                <Typography
                                    sx={{color: "text.secondary", mb: 4}}
                                    variant="body1">
                                    Grants are provided directly to states, territories, tribes, and individual, then
                                    given
                                    to people and organizations who are eligible to receive funding targeted to support
                                    them
                                    in one way or the other.
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid container={true} spacing={4}>
                            <Grid item={true} xs={12} md={4}>
                                <Card
                                    elevation={0}
                                    variant="elevation"
                                    sx={{padding: 3, backgroundColor: "secondary.main", height: "100%"}}>
                                    <CardContent>
                                        <Typography sx={{color: "white", mb: 2}} variant="h6">
                                            Empowerment
                                        </Typography>
                                        <Typography sx={{color: "white"}} variant="body2">
                                            We are committed to empowering individuals
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item={true} xs={12} md={4}>
                                <Card
                                    elevation={0}
                                    variant="elevation"
                                    sx={{padding: 3, backgroundColor: "background.paper", height: "100%"}}>
                                    <CardContent>
                                        <Typography sx={{color: "text.primary", mb: 2}} variant="h6">
                                            Equality And Inclusivity
                                        </Typography>
                                        <Typography sx={{color: "text.secondary"}} variant="body2">
                                            We are dedicated to promoting equality and inclusivity in all our endeavors.
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item={true} xs={12} md={4}>
                                <Card
                                    elevation={0}
                                    variant="elevation"
                                    sx={{padding: 3, backgroundColor: "background.paper", height: "100%"}}>
                                    <CardContent>
                                        <Typography sx={{color: "text.primary", mb: 2}} variant="h6">
                                            Education And Development
                                        </Typography>
                                        <Typography sx={{color: "text.secondary"}} variant="body2">
                                            We believe that education is a catalyst for social transformation.
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </Container>
                </Box>

                <Box
                    whileInView={{
                        y: 0,
                        opacity: 1,
                        transition: {
                            duration: 1
                        }
                    }}
                    initial={{
                        y: "10vh",
                        opacity: 0
                    }}
                    component={motion.div}
                    sx={{py: 8, backgroundColor: "background.alternative"}}>
                    <Container maxWidth="xl">
                        <Grid spacing={4} container={true}>
                            <Grid item={true} xs={12} md={6}>
                                <CardMedia
                                    component="img"
                                    sx={{
                                        objectFit: {xs: "cover"},
                                        borderWidth: 4,
                                        borderColor: "icon.border",
                                        borderStyle: "solid",
                                        borderRadius: 2
                                    }}
                                    src={newFeature}
                                />
                            </Grid>
                            <Grid item={true} xs={12} md={6}>
                                <Typography
                                    sx={{color: "secondary.main", textTransform: "uppercase", mb: 2}}
                                    variant="body1">
                                    NEW FEATURE
                                </Typography>
                                <Typography
                                    sx={{
                                        backgroundImage: "linear-gradient(to right, #af795d , #000000)",
                                        backgroundClip: "text",
                                        color: "transparent",
                                        mb: 2
                                    }}
                                    variant="h4">
                                    Are You Particularly Interested In Grant Programs & Fundraising?
                                </Typography>
                                <Typography
                                    sx={{color: "text.secondary", mb: 2}}
                                    variant="body1">
                                    Our experts are willing to guide you through every process on getting the funds you
                                    need for a big idea.
                                </Typography>
                                <Card
                                    elevation={0}
                                    variant="elevation"
                                    sx={{
                                        backgroundColor: "white",
                                        borderLeftWidth: 4,
                                        borderLeftColor: "secondary.main",
                                        borderLeftStyle: "solid",
                                        mb: 2
                                    }}>
                                    <CardContent>
                                        <Typography
                                            sx={{color: "text.primary", mb: 1, fontWeight: "bold"}}
                                            variant="h6">
                                            Community Course
                                        </Typography>
                                        <Typography sx={{color: "text.secondary"}} variant="body2">
                                            Will be available for all on our Youtube channel
                                        </Typography>
                                    </CardContent>
                                </Card>
                                <Button
                                    fullWidth={true}
                                    variant="text"
                                    startIcon={<DoneOutline sx={{color: "secondary.main", fontSize: 32}}/>}
                                    size="large"
                                    sx={{
                                        textTransform: "none",
                                        color: "text.secondary",
                                        justifyContent: "flex-start"
                                    }}>
                                    Help you achieve greatness and support through the journey
                                </Button>
                                <Button
                                    fullWidth={true}
                                    variant="text"
                                    startIcon={<DoneOutline sx={{color: "secondary.main", fontSize: 32}}/>}
                                    size="large"
                                    sx={{
                                        textTransform: "none",
                                        mb: 3,
                                        color: "text.secondary",
                                        justifyContent: "flex-start"
                                    }}>
                                    Help you to help others
                                </Button>
                                <Button
                                    endIcon={<ArrowRight/>}
                                    disableElevation={true}
                                    variant="contained"
                                    size="large"
                                    color="secondary"
                                    sx={{textTransform: "none", py: 1.2}}>
                                    Coming Soon
                                </Button>
                            </Grid>
                        </Grid>
                    </Container>
                </Box>

                <Box
                    whileInView={{
                        y: 0,
                        opacity: 1,
                        transition: {
                            duration: 1
                        }
                    }}
                    initial={{
                        y: "10vh",
                        opacity: 0
                    }}
                    component={motion.div}
                    sx={{
                    py: 12,
                    backgroundImage: `url(${availableFunds})`,
                    backgroundColor: "background.transparent",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundBlendMode: "overlay",
                    backgroundPosition: "center"
                }}>
                    <Container>
                        <Typography
                            align="center"
                            variant="body2"
                            sx={{
                                backgroundImage: "linear-gradient(to right, #ffffff , #EFE7E2)",
                                backgroundClip: "text",
                                color: "transparent",
                                fontSize: {xs: 32, md: 48, lg: 72},
                                mb: 4
                            }}>
                            We Have A Total Of $2,400,000 In Funding Available
                        </Typography>
                        <Grid container={true} spacing={4} justifyContent="center">
                            <Grid item={true} xs={12} md={3} lg={3}>
                                <Link to="/apply" style={{textDecoration: "none"}}>
                                    <Button
                                        fullWidth={true}
                                        disableElevation={true}
                                        variant="contained"
                                        size="large"
                                        color="secondary"
                                        sx={{textTransform: "none", py: 1.2}}>
                                        Apply Now
                                    </Button>
                                </Link>
                            </Grid>
                        </Grid>
                    </Container>
                </Box>

                <Box
                    whileInView={{
                        y: 0,
                        opacity: 1,
                        transition: {
                            duration: 1
                        }
                    }}
                    initial={{
                        y: "10vh",
                        opacity: 0
                    }}
                    component={motion.div}
                    sx={{py: 8, backgroundColor: "background.default"}}>
                    <Container maxWidth="xl">
                        <Grid spacing={4} container={true}>
                            <Grid item={true} xs={12} md={4}>
                                <Typography
                                    sx={{color: "secondary.main", textTransform: "uppercase", mb: 2}}
                                    variant="body1">
                                    COMMUNITY IMPACTS
                                </Typography>
                                <Typography
                                    sx={{
                                        backgroundImage: "linear-gradient(to right, #af795d , #000000)",
                                        backgroundClip: "text",
                                        color: "transparent",
                                        mb: 2
                                    }}
                                    variant="h4">
                                    Lets Know How We Have Been Able To Help You
                                </Typography>
                                <Typography
                                    sx={{color: "text.secondary", mb: 2}}
                                    variant="body1">
                                    The information you provide we enable us know what most people need and also improve
                                    the positive rating of the funds released
                                </Typography>
                                <Button
                                    fullWidth={true}
                                    variant="text"
                                    startIcon={<DoneOutline sx={{color: "secondary.main", fontSize: 32}}/>}
                                    size="large"
                                    sx={{
                                        textTransform: "none",
                                        color: "text.secondary",
                                        justifyContent: "flex-start"
                                    }}>
                                    This also encourage others
                                </Button>
                                <Button
                                    fullWidth={true}
                                    variant="text"
                                    startIcon={<DoneOutline sx={{color: "secondary.main", fontSize: 32}}/>}
                                    size="large"
                                    sx={{
                                        textTransform: "none",
                                        mb: 3,
                                        color: "text.secondary",
                                        justifyContent: "flex-start"
                                    }}>
                                    Help others with the right info
                                </Button>
                                <Button
                                    endIcon={<ArrowRight/>}
                                    disableElevation={true}
                                    variant="contained"
                                    size="large"
                                    color="secondary"
                                    sx={{textTransform: "none", py: 1.2}}>
                                    Learn More
                                </Button>
                            </Grid>
                            <Grid item={true} xs={12} md={4}>
                                <CardMedia
                                    component="img"
                                    sx={{
                                        objectFit: {xs: "cover"},
                                        borderWidth: 4,
                                        borderColor: "icon.border",
                                        borderStyle: "solid",
                                        borderRadius: 2
                                    }}
                                    src={communityImpact}
                                />
                            </Grid>
                            <Grid item={true} xs={12} md={4}>
                                <Box>
                                    <Stack spacing={4}>
                                        <Card
                                            elevation={0}
                                            variant="elevation"
                                            sx={{padding: 3, backgroundColor: "secondary.main", height: "100%"}}>
                                            <CardContent>
                                                <Typography sx={{color: "white", mb: 2}} variant="h6">
                                                    Give Funding Safes Life
                                                </Typography>
                                                <Typography sx={{color: "white"}} variant="body2">
                                                    Since the days of grant, there has been significant reduction of
                                                    suicide rate.
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                        <Card
                                            elevation={0}
                                            variant="elevation"
                                            sx={{padding: 3, backgroundColor: "background.paper", height: "100%"}}>
                                            <CardContent>
                                                <Typography sx={{color: "text.primary", mb: 2}} variant="h6">
                                                    Dreams Are Now Reality
                                                </Typography>
                                                <Typography sx={{color: "text.secondary"}} variant="body2">
                                                    Given out fund helps great tinker achieve there dreams.
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                        <Card
                                            elevation={0}
                                            variant="elevation"
                                            sx={{padding: 3, backgroundColor: "background.paper", height: "100%"}}>
                                            <CardContent>
                                                <Typography sx={{color: "text.primary", mb: 2}} variant="h6">
                                                    Helping Many People
                                                </Typography>
                                                <Typography sx={{color: "text.secondary"}} variant="body2">
                                                    Apart from the duty call, we find it pleasurable to help as
                                                    many as we can.
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    </Stack>
                                </Box>
                            </Grid>
                        </Grid>
                    </Container>
                </Box>


                <Box
                    whileInView={{
                        y: 0,
                        opacity: 1,
                        transition: {
                            duration: 1
                        }
                    }}
                    initial={{
                        y: "10vh",
                        opacity: 0
                    }}
                    component={motion.div}
                    sx={{
                    py: 12,
                    backgroundImage: `url(${grantPrograms})`,
                    backgroundColor: "background.transparent",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundBlendMode: "overlay",
                    backgroundPosition: "center"
                }}>
                    <Container>
                        <Typography
                            sx={{
                                color: "white",
                                mb: 2,
                                textTransform: "uppercase"
                            }}
                            variant="body1">
                            GRANT PROGRAMS
                        </Typography>
                        <Typography
                            sx={{
                                backgroundImage: "linear-gradient(to right, #EFE7E2 , #ffffff)",
                                backgroundClip: "text",
                                color: "transparent",
                                mb: 2
                            }}
                            variant="h4">
                            See & Apply Our Available Grants Programs
                        </Typography>
                        <Box sx={{mb: 4}}>
                            <Link to="/apply" style={{textDecoration: "none"}}>
                                <Button
                                    disableElevation={true}
                                    variant="contained"
                                    size="large"
                                    color="secondary"
                                    sx={{textTransform: "none", py: 1.2}}>
                                    Apply Now
                                </Button>
                            </Link>
                        </Box>

                        <Grid container={true} spacing={4}>
                            <Grid item={true} xs={12} md={4}>
                                <Box
                                    sx={{
                                        position: "relative",
                                        borderRadius: 1,
                                        backgroundColor: "background.paper",
                                        padding: 1.5,
                                        height: "100%"
                                    }}>
                                    <CardMedia
                                        sx={{
                                            height: 300,
                                            objectFit: "cover",
                                            borderRadius: 1
                                        }}
                                        component="img"
                                        src={smallBusinessGrant}
                                    />
                                    <Card
                                        elevation={1}
                                        variant="elevation"
                                        sx={{
                                            borderRadius: 1,
                                            mx: 2,
                                            mt: -8,
                                            zIndex: 1,
                                            position: "relative"
                                        }}>
                                        <CardContent>
                                            <Typography sx={{color: "text.primary", mb: 2}} variant="h6">
                                                Small Business Grant
                                            </Typography>
                                            <Typography sx={{color: "text.secondary"}} variant="body2">
                                                Start your business with ease using the Business Grant program
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Box>
                            </Grid>
                            <Grid item={true} xs={12} md={4}>
                                <Box
                                    sx={{
                                        position: "relative",
                                        borderRadius: 1,
                                        backgroundColor: "background.paper",
                                        padding: 1.5,
                                        height: "100%"
                                    }}>
                                    <CardMedia
                                        sx={{
                                            height: 300,
                                            objectFit: "cover",
                                            borderRadius: 1
                                        }}
                                        component="img"
                                        src={studentGrant}
                                    />
                                    <Card
                                        elevation={1}
                                        variant="elevation"
                                        sx={{
                                            borderRadius: 1,
                                            mx: 2,
                                            mt: -8,
                                            zIndex: 1,
                                            position: "relative"
                                        }}>
                                        <CardContent>
                                            <Typography sx={{color: "text.primary", mb: 2}} variant="h6">
                                                Student Grant
                                            </Typography>
                                            <Typography sx={{color: "text.secondary"}} variant="body2">
                                                Help with your studies by rendering financial support.
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Box>
                            </Grid>
                            <Grid item={true} xs={12} md={4}>
                                <Box
                                    sx={{
                                        position: "relative",
                                        borderRadius: 1,
                                        backgroundColor: "background.paper",
                                        padding: 1.5,
                                        height: "100%"
                                    }}>
                                    <CardMedia
                                        sx={{
                                            height: 300,
                                            objectFit: "cover",
                                            borderRadius: 1
                                        }}
                                        component="img"
                                        src={businessImprovementGrant}
                                    />
                                    <Card
                                        elevation={1}
                                        variant="elevation"
                                        sx={{
                                            borderRadius: 1,
                                            mx: 2,
                                            mt: -8,
                                            zIndex: 1,
                                            position: "relative"
                                        }}>
                                        <CardContent>
                                            <Typography sx={{color: "text.primary", mb: 2}} variant="h6">
                                                Business Improvement Grant
                                            </Typography>
                                            <Typography sx={{color: "text.secondary"}} variant="body2">
                                                This is to help expand business, mostly in times of financial need .
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Box>
                            </Grid>
                        </Grid>
                    </Container>
                </Box>


                <Box
                    whileInView={{
                        y: 0,
                        opacity: 1,
                        transition: {
                            duration: 1
                        }
                    }}
                    initial={{
                        y: "10vh",
                        opacity: 0
                    }}
                    component={motion.div}
                    sx={{py: 8, backgroundColor: "background.paper"}}>
                    <Container maxWidth="xl">
                        <Grid spacing={4} container={true}>
                            <Grid item={true} xs={12} md={4}>
                                <CardMedia
                                    component="img"
                                    sx={{
                                        objectFit: {xs: "cover"},
                                        borderWidth: 4,
                                        borderColor: "icon.border",
                                        borderStyle: "solid",
                                        borderRadius: 2
                                    }}
                                    src={fundraiser}
                                />
                            </Grid>
                            <Grid item={true} xs={12} md={8}>
                                <Typography
                                    sx={{color: "secondary.main", textTransform: "uppercase", mb: 2}}
                                    variant="body1">
                                    FUNDRAISING CHARITY EVENTS
                                </Typography>
                                <Typography
                                    sx={{
                                        backgroundImage: "linear-gradient(to right, #af795d , #000000)",
                                        backgroundClip: "text",
                                        color: "transparent",
                                        mb: 2
                                    }}
                                    variant="h4">
                                    Join Our Charity & Fundraising Events For Social Impacts Organization
                                </Typography>
                                <Link to="/contact" style={{textDecoration: "none"}}>
                                    <Button
                                        endIcon={<ArrowRight/>}
                                        disableElevation={true}
                                        variant="contained"
                                        size="large"
                                        color="secondary"
                                        sx={{textTransform: "none", py: 1.2, mb: 3}}>
                                        Contact Us
                                    </Button>
                                </Link>
                                <Box sx={{position: "relative"}}>
                                    <Grid container={true} alignItems="center">
                                        <Grid item={true} xs={12} md={8}>
                                            <CardMedia
                                                component="img"
                                                sx={{
                                                    objectFit: {xs: "cover"},
                                                    borderWidth: 4,
                                                    borderColor: "icon.border",
                                                    borderStyle: "solid",
                                                    borderRadius: 2
                                                }}
                                                src={fundraisingEvent}
                                            />
                                        </Grid>
                                        <Grid item={true} xs={12} md={4}>
                                            <Card
                                                elevation={1}
                                                variant="elevation"
                                                sx={{
                                                    backgroundColor: {xs: "white", md: "background.transparent"},
                                                    backdropFilter: "blur(10px)",
                                                    ml: {xs: 0, md: -20},
                                                    zIndex: 10,
                                                    position: "relative"
                                                }}>
                                                <CardContent>
                                                    <Typography
                                                        sx={{
                                                            color: {xs: "text.primary", md: "white"},
                                                            mb: 1,
                                                            fontWeight: "bold"
                                                        }}
                                                        variant="h6">
                                                        Want To Be Part Of The Movement?
                                                    </Typography>
                                                    <Typography
                                                        sx={{color: {xs: "text.primary", md: "white"}}}
                                                        variant="body2">
                                                        Feel free to contact us and we will provide you all necessary
                                                        information
                                                    </Typography>

                                                    <Divider sx={{my: 3}} light={true}/>

                                                    <Typography
                                                        sx={{
                                                            color: {xs: "text.primary", md: "white"},
                                                            mb: 1,
                                                            fontWeight: "bold"
                                                        }}
                                                        variant="h6">
                                                        Free Organization Apply
                                                    </Typography>
                                                    <Typography
                                                        sx={{color: {xs: "text.primary", md: "white"}}}
                                                        variant="body2">
                                                        You can as well register as an Organization. It is Free.
                                                    </Typography>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid>
                        </Grid>
                    </Container>
                </Box>


                <Box
                    whileInView={{
                        y: 0,
                        opacity: 1,
                        transition: {
                            duration: 1
                        }
                    }}
                    initial={{
                        y: "10vh",
                        opacity: 0
                    }}
                    component={motion.div}
                    sx={{
                        py: 8,
                        borderBottomRightRadius: 64,
                        borderBottomLeftRadius: 64,
                        backgroundColor: "background.default",
                    }}>
                    <Container maxWidth="xl">
                        <Typography
                            align="center"
                            sx={{color: "secondary.main", textTransform: "uppercase", mb: 2}}
                            variant="body1">
                            OUR REVIEWS
                        </Typography>
                        <Typography
                            align="center"
                            sx={{
                                backgroundImage: "linear-gradient(to right, #af795d , #000000)",
                                backgroundClip: "text",
                                color: "transparent",
                                mb: 2
                            }}
                            variant="h4">
                            Recap On Testimonies
                        </Typography>

                        <Box>
                            <Carousel
                                autoPlay={true}
                                autoPlaySpeed={5000}
                                infinite={true}
                                partialVisible={false}
                                keyBoardControl={true}
                                pauseOnHover={true}
                                responsive={
                                    {
                                        superLargeDesktop: {
                                            breakpoint: {min: 1200, max: 2400},
                                            items: 3,
                                            slidesToSlide: 3,
                                            partialVisibilityGutter: 8
                                        },
                                        desktop: {
                                            breakpoint: {max: 1200, min: 900},
                                            items: 3,
                                            slidesToSlide: 3,
                                            partialVisibilityGutter: 8
                                        },
                                        tablet: {
                                            breakpoint: {max: 900, min: 600},
                                            items: 2,
                                            slidesToSlide: 2,
                                            partialVisibilityGutter: 8
                                        },
                                        mobile: {
                                            breakpoint: {max: 600, min: 0},
                                            items: 1,
                                            slidesToSlide: 1,
                                            partialVisibilityGutter: 8
                                        }
                                    }
                                }>{WSF_DATA.REVIEWS.map((review, index) => {
                                return (
                                    <Box sx={{mx: {xs: 0, sm: 2, md: 3}}} key={index}>
                                        <Review review={review}/>
                                    </Box>
                                )
                            })}
                            </Carousel>
                        </Box>
                    </Container>
                </Box>

                <Box
                    whileInView={{
                        y: 0,
                        opacity: 1,
                        transition: {
                            duration: 1
                        }
                    }}
                    initial={{
                        y: "10vh",
                        opacity: 0
                    }}
                    component={motion.div}
                    sx={{
                        py: 12,
                        backgroundImage: `url(${beADonor})`,
                        backgroundColor: "background.transparent",
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        backgroundBlendMode: "overlay",
                        backgroundPosition: "center",

                    }}>
                    <Container maxWidth="md">
                        <Box
                            sx={{
                                p: {xs: 4, md: 6, lg: 8},
                                backgroundColor: "rgba(255, 255, 255, 0.03)",
                                backdropFilter: "blur(5px)",
                                borderRadius: 2
                            }}>
                            <Typography
                                sx={{
                                    color: "white",
                                    mb: 2,
                                    textTransform: "uppercase"
                                }}
                                variant="body1">
                                LET'S BE A DONOR
                            </Typography>
                            <Typography
                                sx={{
                                    backgroundImage: "linear-gradient(to right, #EFE7E2 , #ffffff)",
                                    backgroundClip: "text",
                                    color: "transparent",
                                    mb: 2
                                }}
                                variant="h3">
                                Lets Get It All Working.
                            </Typography>
                            <Typography sx={{color: "white", mb: 3}} variant="body2">
                                Click the APPLY button to begin you grant applications process.
                            </Typography>
                            <Link to="/apply" style={{textDecoration: "none"}}>
                                <Button
                                    disableElevation={true}
                                    variant="contained"
                                    size="large"
                                    color="secondary"
                                    sx={{textTransform: "none", py: 1.2}}>
                                    Apply Now
                                </Button>
                            </Link>
                        </Box>
                    </Container>
                </Box>
            </Box>
        </Layout>
    )
}

export default HomePage;